module.exports = __webpack_public_path__ + "media/assets/charleston/04-feet.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/charleston/04-feet.png
// module id = 537
// module chunks = 0